import customize1 from "../../../../assets/images/docs/tabs/customize1.png";
import customize2 from "../../../../assets/images/docs/tabs/customize2.png";
import customize3 from "../../../../assets/images/docs/tabs/customize3.png";
import * as React from 'react';
export default {
  customize1,
  customize2,
  customize3,
  React
};